module.exports = __webpack_public_path__ + "img/two.1cc74b73.png";